export default function AdBlock({ label = "AD" }) {
    return (
        <div className="ad-block" data-testid="ad-block">
            {label}
        </div>
    );
}
